(function() {
  var $f608241add213a83$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("product-form-event-date-stock")) return;
    customElements.define("product-form-event-date-stock", class ProductFormEventDateStock extends HTMLElement {
      dateInventoryIndex=null;
      eventOptionIndices=null;
      constructor() {
        super();
        this.handleOptionsUpdated = this.handleOptionsUpdated.bind(this);
      }
      connectedCallback() {
        this.productForm = this.closest("product-form");
        if (!this.productForm) return;
        this.productForm.addEventListener("product-form:state-updated", this.handleOptionsUpdated);
        this.updateDateOptionAggregates({
          options: this.productForm.options || [],
          variant: this.productForm.currentVariant || null
        });
      }
      disconnectedCallback() {
        this.productForm?.removeEventListener("product-form:state-updated", this.handleOptionsUpdated);
      }
      handleOptionsUpdated(event) {
        this.updateDateOptionAggregates({
          options: event.detail?.options || [],
          variant: event.detail?.variant || null
        });
      }
      getDateNodes() {
        return this.querySelectorAll("[data-date-aggregate-text]");
      }
      getEventOptionIndices() {
        if (this.eventOptionIndices) return this.eventOptionIndices;
        const optionIndices = this.productForm?.getProductFormStateData?.()?.event?.option_indices || {};
        this.eventOptionIndices = {
          experienceIndex: optionIndices.experience ?? -1,
          dateIndex: optionIndices.date ?? -1
        };
        return this.eventOptionIndices;
      }
      getDateInventoryIndex() {
        if (this.dateInventoryIndex) return this.dateInventoryIndex;
        this.dateInventoryIndex = this.productForm?.getEventDateAggregateMapData?.() || {};
        return this.dateInventoryIndex;
      }
      updateDateOptionAggregates({options: options = [], variant: variant = null}) {
        const dateAvailabilityNodes = this.getDateNodes();
        if (!dateAvailabilityNodes.length) return;
        const {experienceIndex: experienceIndex, dateIndex: dateIndex} = this.getEventOptionIndices();
        if (dateIndex < 0) return;
        const selectedExperience = experienceIndex > -1 ? options[experienceIndex] || variant?.options?.[experienceIndex] || "" : "";
        const threshold = Number(this.productForm?.dataset?.eventLowStockThreshold);
        const hasLowStockThreshold = Number.isFinite(threshold) && threshold > 0;
        const index = this.getDateInventoryIndex();
        const leftLabelTemplate = window.MBF?.strings?.inventory?.left || "Translation missing: en.product.inventory.left";
        const fullLabel = window.MBF?.strings?.inventory?.full || window.MBF?.strings?.soldOut || "Translation missing: en.product.inventory.full";
        const availableLabel = window.MBF?.strings?.available || "Translation missing: en.product.available";
        dateAvailabilityNodes.forEach(node => {
          const dateValue = node.getAttribute("data-date-aggregate-text") || "";
          const key = `${selectedExperience}|||${dateValue}`;
          const fallbackKey = `|||${dateValue}`;
          const aggregate = index[key] || index[fallbackKey] || null;
          const totalDateInventory = aggregate?.totalDateInventory ?? aggregate?.total_date_inventory ?? 0;
          const isDateAvailable = Boolean(aggregate?.isDateAvailable ?? aggregate?.is_date_available);
          let availabilityString = availableLabel;
          let isSoldOut = false;
          let isAvailabilityHidden = true;
          if (!isDateAvailable) {
            availabilityString = fullLabel;
            isSoldOut = true;
            isAvailabilityHidden = false;
          } else if (hasLowStockThreshold && totalDateInventory > 0 && totalDateInventory <= threshold) {
            availabilityString = leftLabelTemplate.replace("{{ count }}", totalDateInventory);
            isAvailabilityHidden = false;
          }
          node.textContent = availabilityString;
          node.classList.toggle("text-scheme-contrast-background", isSoldOut);
          node.classList.toggle("text-scheme-text", !isSoldOut);
          node.setAttribute("aria-hidden", String(isAvailabilityHidden));
        });
      }
    });
  })();
})();